var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-wrap',[_c('grid',{attrs:{"config":_vm.gridConfig}}),_c('editor',{attrs:{"config":{id: _vm.gridConfig.id, api: 'Invoices/Get/'}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }